import { render, staticRenderFns } from "./shixin.vue?vue&type=template&id=6f0fd524&"
import script from "./shixin.vue?vue&type=script&lang=js&"
export * from "./shixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports